import { routeTree } from './routeTree.gen';
import { createRouter } from '@tanstack/react-router';
import { installEmbeddedAppHistorySync } from './services/router/embedded-app-router-bridge';

export const router = createRouter({
  routeTree,
});

installEmbeddedAppHistorySync(router);

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
